export const MERCHANTS = [
	{
		value: 'all',
		label: 'All',
	},
	{
		value: 'sam-advisor',
		label: 'Sam Advisor',
	},
	{
		value: 'jennyfer',
		label: 'Jennyfer',
	},
];
export const PERIODS = [
	{
		value: 'week',
		label: 'Week',
	},
	{
		value: 'month',
		label: 'Month',
	},
	{
		value: 'year',
		label: 'Year',
	},
];
export const REPORT_REASONS = [
	{ value: 'all', label: 'All' },
	{ value: 'spam', label: 'Spam' },
	{ value: 'inappropriate', label: 'Inappropriate' },
	{ value: 'notInteresting', label: 'Not Interesting' },
	{ value: 'other', label: 'Other' },
	{ value: 'AI Automatic', label: 'AI Filter' },
];
export const REPORT_TYPES = [
	{ value: 'all', label: 'All' },
	{ value: 'comment', label: 'Comments' },
	{ value: 'user', label: 'Users' },
	{ value: 'galleryPost', label: 'Photos' },
	{ value: 'questionPost', label: 'Questions' },
	{ value: 'pollPost', label: 'Polls' },
	{ value: 'outfitPost', label: 'Outfits' },
	{ value: 'videoPost', label: 'Videos' },
];

export const STATUSES = [
	{
		value: 'all',
		label: 'All',
	},
	{
		value: 'pending',
		label: 'Pending',
		color: '#FFAF18',
	},
	{
		value: 'unaccepted',
		label: 'Approved',
		color: '#1BC6BE',
	},
	{
		value: 'accepted',
		label: 'Banned',
		color: '#E42844',
	},
];
